<div class="modal-header">
  <h4 class="modal-title">{{taskName}}</h4>
</div>
<div class="modal-body">
  <div class="async-task-modal-dynamic-body" [innerHTML]="htmlDetail"></div>
</div> <!-- /modal body -->
<div class="modal-footer">
  <button class="btn btn-default" (click)="modal.close()">Fermer</button>
</div>